import { inject, Injectable } from '@angular/core'
import { AppLabListService, LowercaseDescription } from './app-lab-list.service'
import { lastValueFrom, switchMap } from 'rxjs'
import { AppLabInfo, GolabLabService, LabService } from '@monorepo/golab-generated'
import { LanguageService } from './language.service'

/**
 * This service is also used in the ils-player.
 * The lab lists are only loaded on demand to prevent unnecessary loading of the lists.
 */
@Injectable({
  providedIn: 'root',
})
export class LabListService extends AppLabListService<LowercaseDescription> {
  private readonly labService = inject(LabService)
  private readonly golabLabService = inject(GolabLabService)
  private readonly languageService = inject(LanguageService)

  private supportedLabList: AppLabInfo[] = []

  constructor() {
    super()
  }

  protected override startLoadList(): void {
    this.getLabLists()
  }

  async getSupportedLabList(): Promise<AppLabInfo[]> {
    if (this.supportedLabList.length === 0) {
      this.supportedLabList = await lastValueFrom(this.labService.labControllerFindSupportedLabList())
    }
    return this.supportedLabList
  }

  private getLabLists(): void {
    this.languageService
      .getCurrentLanguage$()
      .pipe(
        switchMap((currentLanguage) => this.labService.labControllerFindEditorLabList({ language: currentLanguage })),
      )
      .subscribe(this.appLabListSubscriber())

    this.languageService
      .getCurrentLanguage$()
      .pipe(
        switchMap((currentLanguage) =>
          this.golabLabService.golabLabControllerGetNotSupportedLabList({ language: currentLanguage }),
        ),
      )
      .subscribe(this.appLabNotSupportedListSubscriber())
  }
}
